/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idOportunidade: string;
}

export function useCapturarProposta() {
  const postData = async (props: Props) => {
    const CAPTURAR_PROPOSTA = `${backofficeEnviroment}/common/backoffice/capturar-proposta/v1/${props.idOportunidade}`;
    const { data } = await instance.post(CAPTURAR_PROPOSTA);
    return data;
  };

  const mutation = useMutation(postData, {
    onSuccess: () => {
      toast.success("Proposta capturada para análise com sucesso!");
    },
    onError: (error: any) => {
      toast.error(
        `Erro ao capturar proposta. Motivos: ${error.response.data.notifications.map(
          (item: any) => item?.message
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return mutation;
}
